<template>
    <div>
        <h5 class="text-secondary">Customer</h5>

        <b-row v-if="!printView && component.address">
            <!-- form wrap to prevent auto-filling in order search city, state, country -->
             <b-col>
            <b-form>

                    <b-input-group size="sm" prepend="Name">
                        <b-input @input="updateInput('fullName', $event)" v-model="component.fullName"></b-input>
                    </b-input-group>
                    <editable-link-input :value="component.email" name="email" href="mailto:" title="Email" @updateInput="updateInput('email', $event)"></editable-link-input>

                    <b-input-group size="sm" prepend="Phone">
                        <b-input
                            :value="displayPhone"
                            @input="updateInput('phone', $event)"
                            @blur="onPhoneBlur"
                        ></b-input>
                    </b-input-group>

                    <b-input-group v-if="component.notes">
                        <div v-for="(note, index) in component.notes" v-bind:key="index">
                            <em class="form-control">{{ note.text }}</em>
                        </div>
                    </b-input-group>

                    <b-input-group prepend="Customer ID" size="sm">
                        <b-link v-if="showCustomerLink && component.customerId" :to="{ name: 'customers', params: {outsideQuery: { customerId: component.customerId } }}" class="form-control text-primary">{{ component.customerId }}</b-link>
                        <b-input v-else @input="updateInput('customerId', $event)" placeholder="No Customer ID" v-model="component.customerId" type="text" pattern="\d*" inputmode="numeric"></b-input>
                        <b-input-group-append v-if="showCustomerLink">
                            <b-button size="sm" text="Button" @click="showCustomerLink = false" variant="outline-secondary">
                                <b-icon-pencil-square></b-icon-pencil-square>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
            </b-form>
            <b-form>
                <h5 class="text-secondary mt-4">Address</h5>
                     <b-input-group size="sm" prepend="Name">
                        <b-input @input="updateInput('address.name', $event)" v-model="component.address.name"></b-input>
                    </b-input-group>

                    <b-input-group size="sm" prepend="Address 1">
                        <b-input @input="updateInput('address.line1', $event)" v-model="component.address.line1"></b-input>
                    </b-input-group>

                    <b-input-group size="sm" prepend="Address 2">
                        <b-input @input="updateInput('address.line2', $event)" v-model="component.address.line2"></b-input>
                    </b-input-group>

                    <b-input-group size="sm" prepend="Tax ID">
                        <b-input
                            @input="updateInput('address.line3', $event)"
                            v-model="component.address.line3"
                            @blur="onTaxIdBlur"
                        ></b-input>
                    </b-input-group>

                    <b-input-group size="sm" prepend="City, State, Zip">
                        <b-input @input="updateInput('address.city', $event)" v-model="component.address.city"></b-input>
                        <b-input @input="updateInput('address.state', $event)" v-model="component.address.state"></b-input>
                        <b-input @input="updateInput('address.zip', $event)" v-model="component.address.zip"></b-input>
                    </b-input-group>

                    <b-input-group size="sm" prepend="Country">
                        <b-form-select @input="updateInput('address.country', $event)" v-model="component.address.country"
                                :options="countries"
                                value-field="code"
                                text-field="name"></b-form-select>
                    </b-input-group>
            </b-form>
            </b-col>
        </b-row>

        <div v-else-if="component.address">
            <b-row>
                <b-col sm="3">Name</b-col>
                <b-col>
                    <p class="mb-0">{{ component.fullName }}</p>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="3">Address</b-col>
                <b-col>
                    <p v-if="component.address.name && component.address.name !== component.fullName" class="mb-0">{{ component.address.name }}</p>
                    <p class="mb-0">{{ component.address.line1 }}</p>
                    <p class="mb-0" v-if="component.address.line2">{{ component.address.line2 }}</p>
                    <p class="mb-0" v-if="component.address.line3">{{ component.address.line3 }}</p>
                    <p class="mb-0">{{ cityStateZip(component.address) }}</p>
                    <p class="mb-0">{{ country(component.address.country) }}</p>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="3">Email</b-col>
                <b-col style="word-wrap: break-word; width: 10rem;"><b-link :href="'mailto:' + customer.email">{{ component.email }}</b-link></b-col>
            </b-row>

            <b-row v-if="component.notes && component.notes.length">
                <b-col sm="3">Notes</b-col>
                <div v-for="(note, index) in component.notes" v-bind:key="'customernote-' + index">
                    <p class="mb-0">{{ note.text }}</p>
                </div>
            </b-row>
        </div>
    </div>
</template>

<script>
    import EditableLinkInput from "../EditableLinkInput";
    import countryList from "../../assets/countryList";
    import AddressMixin from "../../builders/address";
    import objectMixin from "../../mixins/object";

    export default {
        name: "Customer",
        components: { EditableLinkInput },
        mixins: [ AddressMixin, countryList, objectMixin ],
        props: [ 'customer', 'printView', 'recentlySaved' ],
        mounted() {
            if (this.customer.customerId) {
                this.showCustomerLink = true;
            }
            const customerClone = this.deepClone(this.customer);
            this.clone(customerClone);
            if (!this.component.address) {
                this.component.address = {
                    name: this.component.fullName || '',
                    line1: '',
                    line2: '',
                    line3: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: '',
                };
            } else if (!this.component.address.name) {
                this.component.address.name = this.component.fullName || '';
            }
        },
        watch: {
        recentlySaved(newVal) {
            if (newVal === true) {
                    this.showCustomerLink = true;
                }
            }
        },
        data() {
            return {
                emailEditing: false,
                originalEmail: null,
                showCustomerLink: false,
            }
        },
        methods: {
            onPhoneBlur(event) {
                const value = event && event.target ? event.target.value : '';
                const hasPhone = !!(value && value.trim().length);
                this.$emit('phone-blur', hasPhone);
            },
            onTaxIdBlur(event) {
                const value = event && event.target ? event.target.value : '';
                const hasTaxId = !!(value && value.trim().length);
                this.$emit('tax-id-blur', hasTaxId);
            },
            updateInput(fieldName, newValue) {
                let componentCopy = { ...this.component };

                if (typeof fieldName === 'string' && fieldName.includes('.')) {
                    let [parent, child] = fieldName.split('.');
                    componentCopy[parent] = { ...componentCopy[parent], [child]: newValue };
                } else {
                    if (fieldName === 'customerId') {
                        componentCopy[fieldName] = Number(newValue);
                    } else {
                        componentCopy[fieldName] = newValue;
                    }
                }
                this.component = componentCopy;
                this.$emit('update', 'customer', this.component);
            },
        },
        computed: {
            phone() {
                if (this.customer.phone && this.customer.phone[0]) {
                    return this.customer.phone[0].number;
                } else if (this.customer.phone) {
                    return this.customer.phone;
                }
                return '';
            },
            displayPhone() {
                if (this.component.phone && Array.isArray(this.component.phone) && this.component.phone[0] && this.component.phone[0].number) {
                    return this.component.phone[0].number;
                } else if (typeof this.component.phone === 'string') {
                    return this.component.phone;
                }
                return '';
            }
        }
    }
</script>

<style scoped>
    .input-group-text {
        width: 8rem;
    }
</style>